/*
  Target
  by Quaternius (https://poly.pizza/m/Ev3BbukDFS)
  Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import { useGLTF } from '@react-three/drei'
import type { ObjectMap } from '@react-three/fiber'
import { type JSX } from 'react'
import { Mesh, MeshStandardMaterial } from 'three'
import type { GLTF } from 'three-stdlib'

type GLTFResult = GLTF &
  ObjectMap & {
    nodes: {
      Target005_1: Mesh
      Target005_2: Mesh
      Target005_3: Mesh
    }
    materials: {
      White: MeshStandardMaterial
      Celing: MeshStandardMaterial
      DarkWood: MeshStandardMaterial
    }
  }

export function Target(props: JSX.IntrinsicElements['group']) {
  const { nodes, materials } = useGLTF('/models/target.glb') as GLTFResult
  return (
    <group {...props} dispose={null}>
      <group scale={100}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Target005_1.geometry}
          material={materials.White}
        />

        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Target005_2.geometry}
          material={materials.Celing}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Target005_3.geometry}
          material={materials.DarkWood}
        />
      </group>
    </group>
  )
}

useGLTF.preload('/models/target.glb')
